<div class="cards-wrapper" [class.cards-wrapper-padding]="applyPadding">
  <table
    role="presentation"
    class="qa-side-panel-items"
    #dataTable="mfDataTable"
    [mfData]="items"
    [mfRowsOnPage]="itemsPerPage"
    [mfActivePage]="currentPage"
  >
    <tbody role="presentation" [class.with-footer]="items.length > itemsPerPage" (scroll)="onScroll($event)" *ngIf="!draggable">
      <ng-container *ngTemplateOutlet="rowsTemplate"></ng-container>
    </tbody>
    <tbody
      role="presentation"
      [class.with-footer]="items.length > itemsPerPage"
      (scroll)="onScroll($event)"
      dragula="templateItems"
      [(dragulaModel)]="items"
      *ngIf="draggable"
    >
      <ng-container *ngTemplateOutlet="rowsTemplate"></ng-container>
    </tbody>
    <tfoot role="presentation" *ngIf="showPagination && items.length > paginationThreshold">
      <tr role="presentation">
        <td role="presentation">
          <div class="d-flex">
            <app-pagination
              [paginationId]="paginationId"
              [shownPagesCount]="3"
            ></app-pagination>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>

<ng-template #rowsTemplate>
  @for (item of dataTable.data(); let i = $index; track item) {
  <tr role="presentation" #row>
    <td role="presentation" class="d-flex data-table-row" [id]="paginationId + '_' + item.id" [ngClass]="paginationId + '_i_' + i">
      <ng-template [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ item: item, index: i }"></ng-template>
    </td>
  </tr>
  }
</ng-template>
